/* Append catalog pages while retaining the theme's native filtering and cards. */
if (!customElements.get('tandoori-infinite-scroll')) {
  customElements.define('tandoori-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.next = this.querySelector('.page-number-next')?.href;
      this.button = this.querySelector('[data-scroll-more]');
      this.status = this.querySelector('[data-scroll-status]');
      this.grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
      if (!this.grid || !this.next || !('IntersectionObserver' in window)) return;
      this.querySelector('[data-scroll-fallback]').hidden = true;
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.load());
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.load();
      }, { rootMargin: '0px 0px 450px 0px' });
      this.observer.observe(this.button);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }

    async load() {
      if (this.busy || !this.next || !this.isConnected || this.closest('.collection.loading')) return;
      this.busy = true;
      this.button.disabled = true;
      this.status.textContent = this.dataset.loading;
      this.grid.setAttribute('aria-busy', 'true');
      const locationAtStart = location.href;
      const url = new URL(this.next, location.origin);
      url.searchParams.set('section_id', this.dataset.section);
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 15000);
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Page request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = html.querySelector('#product-grid');
        if (!incoming || !incoming.children.length) throw new Error('Missing product grid');
        if (!this.isConnected || location.href !== locationAtStart || this.closest('.collection.loading')) return;
        this.grid.append(...incoming.children);
        this.next = html.querySelector('tandoori-infinite-scroll .page-number-next')?.getAttribute('href');
        this.status.textContent = this.next ? this.dataset.loaded : this.dataset.done;
        if (!this.next) {
          this.observer.disconnect();
          this.button.hidden = true;
        }
      } catch {
        if (!this.isConnected) return;
        this.observer.disconnect();
        this.status.textContent = this.dataset.error;
        this.querySelector('[data-scroll-fallback]').hidden = false;
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        this.button.disabled = false;
        this.grid.removeAttribute('aria-busy');
      }
    }
  });
}
